var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-form',{on:{"submit":function($event){$event.preventDefault();}}},[_c('tiles-form',{attrs:{"doc":_vm.doc}}),_c('v-btn',{on:{"click":_vm.onSubmit}},[_vm._v("Submit")]),_c('pre',[_vm._v("      "+_vm._s(_vm.doc)+"\n    ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }